/**
 * Created by lihanying on 2017/6/29.
 */
import { API_DOMAIN } from '../../config'
import 'whatwg-fetch'
import { fetchData, postData } from '../../util/index'
import { GETCLUBSTORAGE } from './constants'

export const getClubStorage = (payload) => {
  return {
    type: GETCLUBSTORAGE,
    payload,
  }
}

//所有,非普通,普通,商品
export function fetchClubStorage(a, body) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/BusinessApi/${a}`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((data) => {
      dispatch(getClubStorage(data.list))
      return data
    })
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubStorage/action.js